module.exports = __webpack_public_path__ + "media/images/lb/109-44a024626dc41d4ee827d14f14973f99.svg";